module.exports = __webpack_public_path__ + "static/img/12.c9db7d1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/4/2/sp/12.png
// module id = sr9K
// module chunks = 0